export interface ItemDescription {
  id: HalloweenItem;
  name: string;
  address: string;
}

export interface ItemWithQuantity extends ItemDescription {
  quantity: number;
}

export enum HalloweenItem {
  Axe = 'axe',
  Torch = 'torch',
  Bat = 'bat',
  Bones = 'bones',
  Bug = 'bug',
  Flowers = 'flowers',
  Mahogany = 'mahogany',
  Minerals = 'minerals',
  Mushrooms = 'mushrooms',
  Roots = 'roots',
  PirateHead = 'pirate-head',
  DeadWater = 'dead-water',
  Resin = 'resin',
  Rope = 'rope',
  Potion = 'potion',
  Antidote = 'antidote',
  Heart = 'heart',
  Gold = 'gold',
  Pearl = 'pearl',
  GoldOre = 'goldOre',
  Leaf = 'leaf'
}

export interface ExpectedRewardItem {
  token: ItemDescription;
  minQuantity: number;
  maxQuantity: number;
}
